import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps, FormFields } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { Contributions } from '../../components/Contributions/Contributions';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { IsSpouseSingleBeneficiary } from '../../components/IsSpouseSingleBeneficiary/IsSpouseSingleBeneficiary';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Liquidity } from '../../components/Liquidity/Liquidity';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { NonElectiveContribution } from '../../components/NonElectiveContribution/NonElectiveContribution';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { TaxStatus } from '../../components/TaxStatus/TaxStatus';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  const { watch } = useFormContext<FormFields>();

  const taxStatus = watch('bankAccount.TaxStatus');

  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <ManagementStyle />
      {taxStatus === null && <AssetBucketing />}
      <TaxStatus />
      <Contributions isPercentageDefaultContribution />
      <GrossEstateCheckbox />
      <Liquidity />
      <NonElectiveContribution />
      <BrokerOfRecord />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
      <IsSpouseSingleBeneficiary />
    </TabWrapper>
  );
};

export const SimpleIRA = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Account Details', Component: AccountDetails },
      ]}
    />
  );
};
